import { Injectable } from '@angular/core';

/**
 * Whitelabelling values for the register application.
 *
 * Read from the data-branding attribute the host view renders, not from window['Claims'].
 * ViewBase.Write HTML-encodes every value it emits, which is correct for an attribute (browsers
 * decode those) but wrong inside a script literal, where a company name of "O'Brien Motors"
 * would arrive as "O&#39;Brien Motors". The attribute route needs no new encoder.
 *
 * Every field defaults to its current XMPro value, so a cached host page missing the element
 * cannot render "undefined" into an img src.
 */
@Injectable()
export class BrandingService {
    public readonly companyName: string = 'XMPro';
    public readonly websiteUrl: string = 'https://www.xmpro.com';
    public readonly supportEmail: string = 'support@xmpro.com';
    public readonly supportUrl: string = 'https://xmpro.com/contact-us/';
    public readonly privacyPolicyUrl: string = 'https://xmpro.com/privacy-policy';
    public readonly termsOfServiceUrl: string = 'https://xmpro.com/privacy-policy/';
    // The promotional block's terms link had its own vendor target. One configured terms URL
    // serves both links, as the rebadge script did, but each keeps its own default until then.
    public readonly freeTrialTermsUrl: string = 'https://xmpro.com/free-trial-terms/';
    public readonly logoUrl: string = '/identity/content/icons/XMPro-Logo2x.png';
    public readonly logoUrlDark: string = '/identity/content/icons/XMPro-White.png';
    public readonly hideLogo: boolean = false;
    public readonly hideRegisterMarketingPanel: boolean = false;
    public readonly hideRegisterReturnToSignIn: boolean = false;

    constructor() {
        const element = document.getElementById('xm-branding');
        const raw = element ? element.getAttribute('data-branding') : null;
        if (!raw) {
            return;
        }

        let values: any;
        try {
            values = JSON.parse(raw);
        } catch (e) {
            // A malformed attribute must not stop the page rendering; the defaults above stand.
            return;
        }

        this.companyName = values.companyName || this.companyName;
        this.websiteUrl = values.websiteUrl || this.websiteUrl;
        this.supportEmail = values.supportEmail || this.supportEmail;
        this.supportUrl = values.supportUrl || this.supportUrl;
        this.privacyPolicyUrl = values.privacyPolicyUrl || this.privacyPolicyUrl;
        this.termsOfServiceUrl = values.termsOfServiceUrl || this.termsOfServiceUrl;
        this.freeTrialTermsUrl = values.termsOfServiceUrl || this.freeTrialTermsUrl;
        this.logoUrl = values.logoUrl || this.logoUrl;
        this.logoUrlDark = values.logoUrlDark || this.logoUrlDark;
        // Explicit comparison rather than the `||` the strings use: these default to false, so
        // `false || false` would read as a coincidence rather than intent, and would silently
        // invert if a default ever became true.
        this.hideLogo = values.hideLogo === true;
        this.hideRegisterMarketingPanel = values.hideRegisterMarketingPanel === true;
        this.hideRegisterReturnToSignIn = values.hideRegisterReturnToSignIn === true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Services/BrandingService.ts